export default __webpack_public_path__ + "static/media/Back.8f83509e.png";